<template>
  <div>
    <AppLoading/>
    <main class="main" data-ma-theme="blue" :class="{'main--fix': !topbarVisible && sidebarVisible}">
      <AppHeader v-if="topbarVisible"/>
      <NavigationTrigger sidebar v-if="!topbarVisible"/>
      <AppSidebar v-if="sidebarVisible"/>
      <section class="content" :class="{'content--boxed': !sidebarVisible}">
        <router-view></router-view>
      </section>
    </main>
  </div>
</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex';

import AppLoading from './app-loading';
import AppHeader from './app-header';
import AppSidebar from './app-sidebar';
import NavigationTrigger from './navigation-trigger.vue';

export default {
  components: {AppLoading, AppHeader, AppSidebar, NavigationTrigger},
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'topbarVisible',
      'sidebarVisible',
    ])
  },
  watch: {},
  methods: {
    ...mapActions([
      'fetchSpInfo'
    ]),
  },
  beforeCreated() {
  },
  created() {
  },
  mounted() {
    if (!this.topbarVisible) {
      this.fetchSpInfo().catch(() => {
      });
    }
  }
}
</script>
<style lang="scss">
.main--fix {
  @media (min-width: 1200px) {
    .content:not(.content--boxed):not(.content--full) {
      padding-top: 0;
    }

    .sidebar {
      padding-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue